<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form">
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="班级">
                    <el-select v-model="form.classId" filterable clearable placeholder="请选择">
                        <el-option
                            v-for="item in classList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div>
                <el-button type="primary" @click="add()">添加考生</el-button>
                <el-button type="danger" @click="emptyStudent()">清空学员</el-button>
                <el-button type="primary" @click="exportStudent()"><i class="el-icon-download"></i>导出</el-button>
            </div>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="180"
                    prop="name"
                    label="学生姓名">
                </el-table-column>
                <el-table-column
                    prop="testNumber"
                    min-width="180"
                    label="考号">
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="120"
                >
                    <template slot-scope="scope">
                        <el-popconfirm @onConfirm="remove(scope.row)"
                                       title="确认移除该考生吗？"
                        >
                            <div slot="reference" class="fx fx-center">
                                <el-button type="danger" icon="el-icon-minus" circle size="mini"
                                           style="padding: 2px"></el-button>
                                <span class="remove_btn ">移除</span>
                            </div>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>

        <AddDrawer v-if="showAdd" @submit="loadData"
                   @close="showAdd=false" :item="editItem"></AddDrawer>
    </div>
</template>

<style scoped>
.class_title {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    font-size: 16px;

}

.class_title i.iconfont {
    font-size: 20px;
    color: var(--primary);
}

.remove_btn {
    margin-left: 5px;
    cursor: pointer;
    font-size: 16px;
}

.remove_btn:hover {
    color: var(--danger);
}

</style>
<style>

</style>

<script>
import AddDrawer from './StudentAddDrawer';

export default {
    components: {
        AddDrawer,
    },
    props: [
        "attr"
    ],
    data() {
        return {
            showAdd: false,
            exam: this.attr && this.attr.exam,
            form: {
                keywords: "",
                enable: null,
                examId: (this.attr && this.attr.exam) ? this.attr.exam.id : null,
            },
            pager: {
                pageSize: 12,
                dataTotal: 0,
                currentPage: 1
            },
            tableData: [],
            classList: [],
        }
    },

    watch: {
        "form": {
            handler: function (newValue) {
                if (this.form.examId) {
                    this.pager.currentPage = 1;
                    this.loadData();
                } else {
                    this.pager.currentPage = 1;
                    this.pager.dataTotal = 0;
                    this.tableData = [];
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        add() {
            this.editItem = {...this.exam};
            this.showAdd = true;
        },
        emptyStudent() {
            this.$ajaxGet("/examStudent/delByExamId/" + this.form.examId, (data) => {
                this.$showSuccess("操作成功");
                this.loadData();
            })
        },
        loadData() {
            this.$ajaxPost("/exam/getExamPaperUserByExamTestId", {
                form: this.form,
                examId: this.form.examId,
                pager: {...this.pager, dataTotal: 0}
            }, (data) => {
                //分页不能带offset，否则会影响后台计算最新offset
                let {offset, ...pager} = data.pager;
                this.pager = pager;
                this.tableData = data.result;
                this.showAdd = false;
            })
        },
        exportStudent() {
            let examId = this.form.examId;
            let classId = this.form.classId;
            let str = examId + "-" + classId;
            window.open("/exam/exportStudent/" + str + "?token=" + localStorage.getItem("token"));
        },
        pageChange(page) {
            this.pager.currentPage = page;
            this.loadData();
        },
        remove(user) {
            this.$ajaxGet("/examStudent/del/" + user.examStudentId, data => {
                this.loadData();
            })
        },
        initClassSelect() {
            this.$ajaxPost("/exam/getExamClassList/" + this.form.examId, {}, (data) => {
                if (data && data.result && data.success) {
                    this.classList = data.result;
                }
            })
        },
    },
    created() {
        this.loadData();
        this.initClassSelect();
    }
}
</script>
